<template>
  <div class="product">
    <div class="wrapper">
      <TopNav :current-lang="'en'" :current-page="'product'"></TopNav>
      <div class="feature" ref="featureRef">
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>Yanghe Daqu New Sky Blue</h3>
              <h4>Classic</h4>
              <p>Classic craftsmanship with a rich aroma and mellow taste. Suitable for daily drinking, business
                banquets, and gifts, combining tradition and innovation.</p>
              <div class="buy-now-btn" @click="navTo('','','#purchase')">BUY NOW ></div>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/g/1.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="img">
              <img src="../assets/imgs/product/g/2.jpg" alt="">
            </div>
            <div class="intro">
              <h3>CRAFTSMANSHIP</h3>
              <p>
                Traditional Craftsmanship: Yanghe Daqu New Sky Blue continues the classic Yanghe brewing techniques,
                using traditional Daqu fermentation to maintain the unique flavor of Yanghe baijiu.
              </p>
              <p>
                Modern Technology: Combines modern technological methods to optimize fermentation and distillation
                processes, enhancing the purity and flavor stability of the baijiu.
              </p>
              <p>
                Premium Ingredients: Selects high-quality sorghum, rice, and wheat to ensure the highest quality in
                every bottle.
              </p>
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>TASTE</h3>
              <p>
                Full-bodied Flavor: Offers a rich aroma that includes floral, fruity, and grain notes, with a full and
                harmonious taste.
              </p>
              <p>
                Smooth Entry: Enters the mouth smoothly and gently, without irritating the throat, making it suitable
                for various consumers.
              </p>
              <p>
                Long-lasting Aftertaste: Provides a long, sweet aftertaste with rich layers and a subtle, elegant
                finish.
              </p>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/g/3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="img">
              <img src="../assets/imgs/product/g/4.jpg" alt="">
            </div>
            <div class="intro">
              <h3>APPEARANCE</h3>
              <p>
                Bottle Design: Combines modern fashion elements with traditional style, with a blue bottle symbolizing
                purity and elegance.
              </p>
              <p>
                Exquisite Packaging: The packaging is meticulously designed, making it suitable as a gift and enhancing
                the product's visual appeal.
              </p>
              <p>
                Brand Marking: The bottle and packaging prominently feature the Yanghe brand logo, highlighting the
                brand's history and reputation.
              </p>
            </div>
          </div>
        </div>
        <div class="row-wrapper">
          <div class="row">
            <div class="intro">
              <h3>OTHER FEATURES</h3>
              <p>
                Classic Inheritance: As part of the Yanghe Daqu series, New Sky Blue continues the classic brewing
                craftsmanship and quality of Yanghe Distillery.
              </p>
              <p>
                Market Positioning: Positioned in the mid-to-high-end market, offering excellent value for money.
              </p>
              <p>
                Brand Trust: Yanghe brand enjoys high recognition and a good reputation in the market, with consumers
                having high trust in its products.
              </p>
            </div>
            <div class="img">
              <img src="../assets/imgs/product/g/5.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="consumer" ref="consumerRef">
        <h1>Suitable Consumer Groups and Occasions</h1>
        <div class="group-wrapper">
          <div class="group">
            <img src="../assets/imgs/tc-rcyy.png" alt="">
            <p>
              Daily Consumption
            </p>
          </div>
          <div class="group">
            <img src="../assets/imgs/tc-swyq.png" alt="">
            <p>
              Business Banquets
            </p>
          </div>
          <div class="group">
            <img src="../assets/imgs/tc-jtjh.png" alt="">
            <p>
              Family Gatherings
            </p>
          </div>
        </div>
      </div>
      <Purchase></Purchase>
      <div class="like" ref="likeRef">
        <h1>You May Also Like</h1>
        <div class="recommend-wrapper">
          <div class="recommend">
            <a href="/product/Sky-Blue"><img src="../assets/imgs/product/rec/h.png" alt=""></a>
            <p><a href="/product/Sky-Blue">Sky Blue</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Sea-Blue"><img src="../assets/imgs/product/rec/i.png" alt=""></a>
            <p><a href="/product/Sea-Blue">Sea Blue</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Micro-Molecules"><img src="../assets/imgs/product/rec/1.png" alt=""></a>
            <p><a href="/product/Micro-Molecules">Micro Molecules</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Dream-of-Blue-Crystal-Edition"><img src="../assets/imgs/product/a/1.jpg" alt=""></a>
            <p><a href="/product/Dream-of-Blue-Crystal-Edition">Dream of Blue Crystal Edition</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Dream-of-Blue-M6+"><img src="../assets/imgs/product/rec/3.png" alt=""></a>
            <p><a href="/product/Dream-of-Blue-M6+">Dream of Blue M6+</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Dream-of-Blue-Handmade-Edition"><img src="../assets/imgs/product/rec/4.png" alt=""></a>
            <p><a href="/product/Dream-of-Blue-Handmade-Edition">Dream of Blue Handmade Edition</a></p>
          </div>
          <!--          <div class="recommend">-->
          <!--            <img src="../assets/imgs/product/rec/5.png" alt="">-->
          <!--            <p>Yanghe Daqu New Sky Blue</p>-->
          <!--          </div>-->
          <div class="recommend">
            <a href="/product/Blue-Classic"><img src="../assets/imgs/product/rec/6.png" alt=""></a>
            <p><a href="/product/Blue-Classic">Blue Classic</a></p>
          </div>
          <div class="recommend">
            <a href="/product/Dream-of-Blue-M9"><img src="../assets/imgs/product/rec/7.png" alt=""></a>
            <p><a href="/product/Dream-of-Blue-M9">Dream of Blue M9</a></p>
          </div>
        </div>
      </div>
      <BottomNav :current-lang="'en'" :current-page="'product'"></BottomNav>
      <!-- 遮罩 -->
      <!--      <div class="mask" v-show="isMask">-->
      <!--        <img id="load1" alt="" src="../assets/imgs/load.gif" class="mask__load"/>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
// import {zoomElement} from '@/utils/zoom.js';
import {minxin} from "@/utils/minxin";
import TopNav from "@/components/TopNav";
import BottomNav from "@/components/BottomNav";
import Purchase from "@/components/Purchase";

export default {
  name: "Home", //翻页
  mixins: [minxin],
  props: [],
  components: {
    Purchase,
    BottomNav,
    TopNav,
  },
  data() {
    return {
      timer: null, // 定时器
      isMask: true, //显示遮罩
    }
  },
  created() {
    const that = this;
    console.log(window.location.hash);
  },
  mounted() {
    const that = this;
    // 监听 resize 方法
    window.addEventListener("resize", that.renderResize, false);

    that.timer = setInterval(function () {
      // console.log("document.readyState === 2", document.readyState)
      if (document.readyState === 'complete') {
        that.isMask = false;
        window.clearInterval(that.timer)

        //获取需要缩放的dom元素
        // let zoomEl = that.$refs.;
        // console.log("zoomEl:" + zoomEl);
        // zoomElement(zoomEl);
      }
    }, 2000);
    window.scrollTo(0, 0);
  },
  beforeCreate() {
  },
  beforeDestroy() {
    const that = this;
    // 移除监听
    window.removeEventListener("resize", that.renderResize, false)
  },
  computed: {},
  methods: {
    renderResize() {
      console.log('on resize');
      const that = this;

      that.$nextTick(() => {
        console.log('on resize $nextTick');
        that.$forceUpdate();
      });

      // 做页面适配
      // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
    },
  },
  metaInfo: {
    title: 'YANGHE.SG',
    meta: [
      {
        name: 'keywords',
        content: 'YANGHE, Yanghe Daqu New Sky Blue'
      },
      {
        name: 'description',
        content: 'YANGHE, Yanghe Daqu New Sky Blue'
      }
    ]
  }
}
</script>
<style lang="less" scoped>

.product {
  background-color: rgba(255, 255, 255, 0.55);
  position: relative;
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0; //固定元素,不被挤压

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1920PX;
    width: 100%;

    .feature {
      width: 100%;
      padding-bottom: 48px;
      text-align: left;

      .row-wrapper {
        margin: 0 auto;

        .row {
          display: flex;
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-evenly;
          justify-items: flex-start;
          padding-top: 50px;
          padding-bottom: 50px;
          width: 100%;

          .intro {
            width: 35%;
            margin-bottom: 60px;
            text-align: left;

            h3 {
              font-size: 32px;
              font-weight: bold;
              margin-left: 12px;
              margin-right: 12px;
            }

            h4 {
              color: #d5bb8e;
              font-size: 18px;
              font-weight: normal;
              margin-left: 12px;
              margin-right: 12px;
            }

            p {
              font-size: 22px;
              margin-left: 12px;
              margin-right: 12px;
            }
          }

          .img {
            width: 360px;
            height: 360px;
            border: 1px solid #0634ad;
            //box-shadow: 2px 2px 2px 2px rgba(6, 52, 173, .2);
            background-color: #ffffff;
            //padding: 30px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

      }

      .row-wrapper:nth-child(even) {
        background-color: #ebeff1;

        h3 {
          color: #01aaf4;
        }
      }

      .buy-now-btn {
        background-color: #01aaf4;
        border-radius: 4px;
        width: 116px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: normal;
        color: #ffffff;
        display: block;
        text-align: center;
        margin-left: 10px;;
        margin-top: 60px;
        cursor: pointer;
      }
    }

    .consumer {
      display: block;
      background-color: #ebeff1;
      width: 100%;
      padding-top: 40px;
      padding-bottom: 40px;

      .group-wrapper {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-wrap: wrap;
        justify-content: space-evenly;
        justify-items: flex-start;
        background-color: #ebeff1;
        width: 80%;
        margin: 0 auto;

        .group {
          width: 300px;
          height: 329px;

          img {
            width: 206px;
            height: 206px;
          }

          p {
            color: #666666;
            font-size: 22px;
            line-height: 28px;
            text-align: center;
            //padding-top: 50px;
          }
        }
      }

      h1 {
        font-size: 32px;
        color: #01aaf4;
        text-align: center;
        padding-right: 20px;
        padding-bottom: 40px;
      }
    }

    .like {
      padding-bottom: 48px;

      h1 {
        font-size: 34px;
        font-weight: bold;
      }

      .recommend-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: flex-start;
        padding-left: 140px;
        padding-right: 140px;
        padding-top: 30px;

        .recommend {
          width: 26%;
          margin-bottom: 40px;
          text-align: center;

          img {
            width: 250px;
            height: 250px;
            border: 1px solid #0634ad;
          }

          p {
            font-size: 18px;
            margin-left: 12px;
            margin-right: 12px;
          }

          a:link {
            color: #2c3e50;
            text-decoration: none;
          }

          a:visited {
            color: #2c3e50;
          }

          a:hover {
            color: #d5bb8e;
            cursor: pointer;
          }
        }

      }

      .view-more-btn {
        background-color: #01aaf4;
        border-radius: 4px;
        width: 116px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        display: block;
        text-align: center;
        margin: 0 auto;
      }
    }
  }

  .mask {
    z-index: 1000;
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100vw;
    background-color: #BDE4E6;
    display: flex;
    justify-content: center;
    align-items: center;

    .mask__load {
      width: 300px;
      margin-bottom: 100px;
    }
  }
}

@media only screen and (max-width: 820px) {

  .product {
    .wrapper {
      width: 100%;

      .feature {

        .row-wrapper {
          .row {
            .intro {
              width: 50%;

              h3 {
                font-size: 60px;
                line-height: 60px;
              }

              h4 {
                font-size: 40px;
                line-height: 40px;
              }

              p {
                font-size: 44px;
              }
            }

            .img {
              width: 25%;
              height: 25%;
            }
          }

        }

        .buy-now-btn {
          border-radius: 12px;
          width: 330px;
          height: 68px;
          line-height: 68px;
          font-size: 34px;
        }
      }

      .consumer {

        h1 {
          font-size: 60px;
          line-height: 60px;
        }

        h2 {
          font-size: 42px;
          line-height: 42px;
        }

        .group-wrapper {
          .group {
            height: 400px;
            width: 45%;

            p {
              font-size: 36px;
              line-height: 54px;
            }
          }
        }
      }

      .like {
        h1 {
          font-size: 72px;
        }

        .recommend-wrapper {
          .recommend {
            img {
              width: 320px;
              height: 320px;
              border: 1px solid #0634ad;
            }

            p {
              font-size: 28px;
              margin-left: 12px;
              margin-right: 12px;
            }
          }

        }

        .view-more-btn {
          background-color: #01aaf4;
          border-radius: 4px;
          width: 116px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          display: block;
          text-align: center;
          margin: 0 auto;
        }
      }

    }
  }
}

@media only screen and (max-width: 1440px) {
}
</style>
